// extracted by mini-css-extract-plugin
export default {"specialsContainer":"CpaExtraData_specialsContainer__dO2n2","workOrderContainer":"CpaExtraData_workOrderContainer__y-Gbc"};